<template>
    <div class="d-xl-none">
        <b-button pill variant="dark" v-b-toggle.sidebar-1.nav-sidebar>
            <span class="navbar-toggler-icon mx-n1"></span>
            <b-badge class="ml-n1 mt-n5 mr-n2" style="" pill v-if="neueNachrichten > 0">
                {{ neueNachrichten }}
            </b-badge>
        </b-button>
        <b-sidebar width="15em" z-index="2048" title="Menü" right id="nav-sidebar" bg-variant="dark" text-variant="light" shadow>
            <b-nav vertical>
                <b-nav-item v-for="route in routes" style="font-size:1.2em"
                    :key="route.path"
                    :text="route.name"
                    :active="$route.path == route.path"
                    :disabled="$route.path == route.path"
                    @click="$router.push(route.path)"
                >
                    <span>
                        <img v-if="route.meta.icon" 
                            :src="require('../assets/interface/' + route.meta.icon)" 
                            class="align-self-center mt-n1" 
                            :style="$route.path == route.path ? 'filter:invert(100%);height:0.9em' : 'filter:invert(60%);height:0.9em'" 
                        />
                        {{route.name}}
                    </span>
                    <small>
                        <b-badge class="align-self-start" pill v-if="route.path == '/nachrichten' && neueNachrichten > 0">
                            {{ neueNachrichten }}
                        </b-badge>
                    </small>
                </b-nav-item>
                <b-nav-item style="font-size:1.2em" @click="$router.push({ query: { coronawarn: true } })">
                    <img src="../assets/interface/virus.svg" 
                        class="align-self-center mt-n1" 
                        style="filter:invert(60%);height:0.9em" 
                    />
                    Corona-Hinweis 
                </b-nav-item>
                <b-nav-item style="font-size:1.2em" @click="$emit('logout')">
                    <img src="../assets/interface/lock.svg" 
                        class="align-self-center mt-n1" 
                        style="filter:invert(60%);height:0.9em" 
                    />
                    Abmelden 
                </b-nav-item>
                <b-nav-item style="font-size:1.2em" @click="setDarkmode(!darkmode)">
                    <img :src="darkmode ? require('../assets/interface/moon.svg') : require('../assets/interface/sun.svg')" 
                        class="align-self-center mt-n1" 
                        style="filter:invert(60%);height:0.9em" 
                    />
                    Darkmode
                </b-nav-item>
            </b-nav>
        </b-sidebar>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { routes } from '../config'
import { BBadge, BSidebar, BNav, BNavItem, VBToggle } from "bootstrap-vue"
export default {
    name: "NavDesktop",
    components:{
        BBadge, 
        BSidebar, 
        BNav, 
        BNavItem
    },
    directives:{
        'b-toggle': VBToggle
    },
    computed: {
        ...mapGetters(['neueNachrichten', 'darkmode']),
        routes: () => routes.filter(x => x.meta.nav)
    },
    methods: mapActions(['setDarkmode'])
}
</script>